import {
  Box,
  Checkbox,
  CheckboxGroup,
  Divider,
  Flex,
  FormControl,
  FormErrorMessage,
  Grid,
  GridItem,
  RadioGroup,
  Stack,
  Text,
} from "@chakra-ui/react";
import { Field } from "formik";
import { RadioButtonField } from "../../../../../components/RadioButtonField";
import { CustomMultiSelectWField } from "../../../../../components/MultiSelect";
import { PopoverGenero } from "../../../../../components/PopoverGenero";
import { useCallback, useState } from "react";
import DoencaService from "../../../../../../main/services/DoencaService";

export const SaudeAba = ({ children, props, isMobile }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [deficiencias, setDeficiencias] = useState({
    options: [],
    isLoading: false,
  });
  const [doencas, setDoencas] = useState({
    options: [],
    isLoading: false,
  });

  const handleGetDoencas = useCallback(() => {
    setDoencas((doencas) => ({ ...doencas, isLoading: true }));
    DoencaService.listarDoencaAtiva().then((res) => {
      const allOption = { id: "", descricao: "Todos" };
      const modifiedData = res.data.map((doenca) => {
        return {
          idDoenca: doenca.id,
          descricaoDoenca: doenca.descricao,
        };
      });
      setDoencas({ options: [allOption, ...modifiedData], isLoading: false });
    });
  }, []);

  const handleGetDeficiencia = () => {
    setDeficiencias({ ...deficiencias, isLoading: true });

    DoencaService.listarDeficiencia().then((res) => {
      const allOption = { id: "", descricao: "Todos" };
      const tempOptions = res.data.map((deficiencia) => {
        return {
          idTipoDeficiencia: deficiencia.id,
          descricaoTipoDeficiencia: deficiencia.descricao,
        };
      });
      setDeficiencias({
        options: [allOption, ...tempOptions],
        isLoading: false,
      });
    });
  };

  const handleClick = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      <Flex mb={4} justifyContent={"space-between"}>
        <Text
          fontWeight={700}
          fontSize="16px"
          lineHeight="21.6px"
          color={"#575553"}
        >
          Saúde
        </Text>
        {children}
      </Flex>

      <Text
        fontWeight={700}
        fontSize="14px"
        lineHeight="21.6px"
        color={"#169499"}
        mt={7}
        mb={2}
      >
        Deficiência
      </Text>
      <Divider orientation="horizontal" borderColor={"#DDEBEA"} />
      <Box>
        <Text
          color="#5F6377"
          fontWeight="500"
          fontSize="14px"
          lineHeight="19.6px"
          htmlFor={"Possui Deficiência?"}
          mb={4}
          mt={7}
        >
          Possui Deficiência?
        </Text>
        <Grid
          templateColumns="repeat(15, 1fr)"
          gap="15px"
          mt="15px"
          w="100%"
          alignItems={"center"}
        >
          <GridItem colSpan={{ base: 9, "2xl": 7 }}>
            <Field name="radioDeficiencia">
              {({ field, form }) => (
                <FormControl
                  isInvalid={
                    form.errors.radioDeficiencia &&
                    form.touched.radioDeficiencia
                  }
                  id="radioDeficiencia"
                  width="max-content"
                  zIndex={"1"}
                >
                  <RadioGroup
                    value={field.value}
                    onChange={(value) =>
                      props.setFieldValue("radioDeficiencia", value)
                    }
                  >
                    <Stack direction="row" gap={4}>
                      <RadioButtonField
                        id="radio-deficiencia-s"
                        fieldName="radioDeficiencia"
                        value="S"
                        label="Sim"
                      />
                      <RadioButtonField
                        id="radio-deficiencia-n"
                        fieldName="radioDeficiencia"
                        value="N"
                        label="Não"
                      />
                    </Stack>
                  </RadioGroup>
                  <FormErrorMessage mt="-1" mr="-16">
                    {form.errors.radioDeficiencia}
                  </FormErrorMessage>
                </FormControl>
              )}
            </Field>
          </GridItem>
          <GridItem colSpan={{ base: 15 }} zIndex={"3"}>
            <Flex alignItems={props.errors.idGenero ? "center" : "end"} gap={2}>
              <CustomMultiSelectWField
                fieldName="deficiencias"
                label=""
                placeholder="Selecione a Deficiência"
                getOptionLabel={(option) =>
                  option.descricaoTipoDeficiencia || option.descricao
                }
                getOptionValue={(option) => option.idTipoDeficiencia}
                isLoading={deficiencias.isLoading}
                options={deficiencias.options}
                values={props.values.deficiencias[0] || ""}
                onChange={(value) => {
                  props.setFieldValue("deficiencias", value ? value : "");
                }}
                onFocus={
                  deficiencias.options.length === 0
                    ? handleGetDeficiencia
                    : null
                }
                visible={props.values.radioDeficiencia === "S"}
                todos
              />

              {props.values.idGenero && isMobile && (
                <PopoverGenero
                  isOpen={isOpen}
                  setIsOpen={setIsOpen}
                  handleClick={handleClick}
                  labelTextoGenero={
                    props.values?.idGenero?.label?.props?.children[1]?.props
                      ?.label
                  }
                />
              )}
            </Flex>
          </GridItem>
        </Grid>
      </Box>
      <Text
        fontWeight={700}
        fontSize="14px"
        lineHeight="21.6px"
        color={"#169499"}
        mt={7}
        mb={2}
      >
        Problema de Saúde
      </Text>
      <Divider orientation="horizontal" borderColor={"#DDEBEA"} />
      <Box mt={7}>
        <Text
          color="#5F6377"
          fontWeight="500"
          fontSize="14px"
          lineHeight="19.6px"
          htmlFor={"Possui algum Problema de Saúde?"}
          mb={4}
        >
          Possui algum Problema de Saúde?
        </Text>
        <Grid templateColumns="repeat(12, 1fr)" gap="15px" mt="15px" w="100%">
          <GridItem colSpan={{ base: 9, xl: 6, "2xl": 4 }}>
            <Field name="radioProblemaSaude">
              {({ field, form }) => (
                <FormControl
                  isInvalid={
                    form.errors.radioProblemaSaude &&
                    form.touched.radioProblemaSaude
                  }
                  id="radioProblemaSaude"
                  width="max-content"
                  zIndex={"1"}
                >
                  <RadioGroup
                    value={field.value}
                    onChange={(value) =>
                      props.setFieldValue("radioProblemaSaude", value)
                    }
                  >
                    <Stack direction="row" gap={4}>
                      <RadioButtonField
                        id="radio-problema-s"
                        fieldName="radioProblemaSaude"
                        value="S"
                        label="Sim"
                      />
                      <RadioButtonField
                        id="radio-problema-n"
                        fieldName="radioProblemaSaude"
                        value="N"
                        label="Não"
                      />
                    </Stack>
                  </RadioGroup>
                  <FormErrorMessage mt="-1" mr="-16">
                    {form.errors.radioProblemaSaude}
                  </FormErrorMessage>
                </FormControl>
              )}
            </Field>
          </GridItem>
          <GridItem colSpan={{ base: 15 }} zIndex={"2"}>
            <CustomMultiSelectWField
              fieldName="doencas"
              label=""
              placeholder="Selecione a Doença"
              getOptionLabel={(option) =>
                option.descricaoDoenca || option.descricao
              }
              getOptionValue={(option) => option.idDoenca}
              isLoading={doencas.isLoading}
              options={doencas.options}
              values={props.values.doencas[0] || ""}
              onChange={(value) => {
                props.setFieldValue("doencas", value ? value : "");
              }}
              onFocus={doencas.options.length === 0 ? handleGetDoencas : null}
              visible={props.values.radioProblemaSaude === "S"}
              todos
            />
          </GridItem>
        </Grid>
      </Box>
      <Text
        fontWeight={700}
        fontSize="14px"
        lineHeight="21.6px"
        color={"#169499"}
        mt={7}
        mb={2}
      >
        Cartão de Vacinação
      </Text>
      <Divider orientation="horizontal" borderColor={"#DDEBEA"} />
      <Box mt={7}>
        <Text
          color="#5F6377"
          fontWeight="500"
          fontSize="14px"
          lineHeight="19.6px"
          htmlFor={"Faz Restrição de Criança/Adolescente com Deficiência?"}
          mb={2}
        >
          Possui Cartão de Vacinação?
        </Text>

        <Field name="radioCartaoVacinacao">
          {({ field, form }) => (
            <FormControl
              isInvalid={
                form.errors.radioCartaoVacinacao &&
                form.touched.radioCartaoVacinacao
              }
              id="radioCartaoVacinacao"
              width="max-content"
            >
              <CheckboxGroup
                value={field.value || []}
                onChange={(value) =>
                  props.setFieldValue("radioCartaoVacinacao", value)
                }
              >
                <Stack flexDirection="row" alignItems={"end"} gap={4}>
                  <Checkbox id="checkbox-cartaoVacinacao-sim" value="SIM">
                    Sim
                  </Checkbox>

                  <Checkbox
                    isDisabled={props?.values?.radioCartaoVacinacao?.includes(
                      "SIM",
                    )}
                    id="checkbox-cartaoVacinacao-nao"
                    value="NAO"
                  >
                    Não
                  </Checkbox>
                  <Checkbox
                    isDisabled={props?.values?.radioCartaoVacinacao?.includes(
                      "SIM",
                    )}
                    id="checkbox-cartaoVacinacao-sem"
                    value="SEM_INFORMACAO"
                  >
                    Sem Informação
                  </Checkbox>
                </Stack>

                <FormErrorMessage mr="-14">
                  {form.errors.radioCartaoVacinacao}
                </FormErrorMessage>
              </CheckboxGroup>
            </FormControl>
          )}
        </Field>
      </Box>

      <Text
        fontWeight={700}
        fontSize="14px"
        lineHeight="21.6px"
        color={"#169499"}
        mt={7}
        mb={2}
      >
        Medicação Contínua
      </Text>
      <Divider orientation="horizontal" borderColor={"#DDEBEA"} />
      <Box mt={7}>
        <Text
          color="#5F6377"
          fontWeight="500"
          fontSize="14px"
          lineHeight="19.6px"
          htmlFor={"Usa Medicação Contínua?"}
          mb={4}
        >
          Usa Medicação Contínua?
        </Text>
        <Grid templateColumns="repeat(12, 1fr)" gap="15px" mt="15px" w="100%">
          <GridItem colSpan={{ base: 9, xl: 6, "2xl": 4 }}>
            <Field name="radioMedicacaoContinua">
              {({ field, form }) => (
                <FormControl
                  isInvalid={
                    form.errors.radioMedicacaoContinua &&
                    form.touched.radioMedicacaoContinua
                  }
                  id="radioProblemaSaude"
                  width="max-content"
                  zIndex={"1"}
                >
                  <RadioGroup
                    value={field.value}
                    onChange={(value) =>
                      props.setFieldValue("radioMedicacaoContinua", value)
                    }
                  >
                    <Stack direction="row" gap={4}>
                      <RadioButtonField
                        id="radio-problema-s"
                        fieldName="radioMedicacaoContinua"
                        value="S"
                        label="Sim"
                      />
                      <RadioButtonField
                        id="radio-problema-n"
                        fieldName="radioMedicacaoContinua"
                        value="N"
                        label="Não"
                      />
                    </Stack>
                  </RadioGroup>
                  <FormErrorMessage mt="-1" mr="-16">
                    {form.errors.radioMedicacaoContinua}
                  </FormErrorMessage>
                </FormControl>
              )}
            </Field>
          </GridItem>
        </Grid>
      </Box>
    </>
  );
};
